import type { ReadTemplateDetailRead } from '@/services/api/generated/templatesV2Service';
import { useTemplateRetrieveQuery } from '@/services/api/generated/templatesV2Service';

interface UseGetTemplateResult {
  isLoading: boolean;
  error: unknown | null;
  template: ReadTemplateDetailRead | undefined;
}

export const useGetTemplate = (
  templateId: string | null | undefined,
): UseGetTemplateResult => {
  const {
    data: template,
    isLoading,
    error,
  } = useTemplateRetrieveQuery(
    {
      id: templateId as string,
    },
    {
      skip: !templateId,
    },
  );

  return {
    isLoading,
    error: error || null,
    template,
  };
};
